<template>
	<div>
		<b-card-body>
				<p v-if="message" class="text-danger text-center"> Выберите отдел!</p>
				<b-row>
					<b-col cols="3">
						<b-form-group
							breakpoint="lg"
							label-cols="4"
							label-cols-lg="4"
							label-size="sm"
							size="sm">
							<template slot="label">
								{{ $t('incomes.create.warehouse') }} <span class="text-danger">*</span>
							</template>
							<b-form-select
								:options="myDeps.permittedDepartments"
								value-field="id"
								text-field="name"
								v-validate="{required:true}"
								v-model="department"
								@change="depSelected"
								size="sm">
								<template slot="first">
									<option :value="null">-- {{ $t('incomes.create.warehouse') }} --</option>
								</template>
							</b-form-select>
						</b-form-group>
					</b-col>
					<b-col cols="3">
						<b-form-group
							breakpoint="lg"
							label-size="sm"
							label-cols="4"
							:label="$t('pending.regDate')"
						>
							<b-input-group size="sm">
								<masked-input
									v-model="regDate"
									class="form-control form-control-sm "
									mask="11-11-1111"></masked-input>
								<b-input-group-addon>
									<b-button size="sm" disabled>
										<i class="fa fa-calendar"></i>
									</b-button>
								</b-input-group-addon>
							</b-input-group>
						</b-form-group>
					</b-col>
					<b-col cols="4">
						<b-form-group
							size="sm"
							breakpoint="lg"
							label-size="sm"
							label-cols="4"

						>
							<template slot="label">
								{{ $t('pending.rosxojdeniya')}} <span class="text-danger">*</span>
							</template>
							<b-form-select v-model="shortageTypeId"
										   :value-field="'id'"
										   name="shortageTypeId"
										   v-validate="{required: true}"
										   :text-field="'name'"
										   :options="list"
										   size="sm">
								<template slot="first">
									<option :value="null">-- {{$t('pending.select')}} --</option>
								</template>
							</b-form-select>
						</b-form-group>
					</b-col>

				</b-row>
				<b-row>
					<b-col cols="4">
						<b-form-group
							size="sm"
							breakpoint="lg"
							label-size="sm"
							label-cols="4"
						>
							<template slot="label">
								{{$t('employees.full-name')}}<span class="text-danger">*</span>
							</template>
							<b-form-input size="sm" v-validate="{required:true}" v-model="fio"
										  :placeholder="$t('employees.full-name')"></b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<hr>
				<b-row>

					<b-col cols="6">
						<b-form-group
							breakpoint="lg"
							label-size="sm"
							label-cols="2"
							label-for="refName"
							class="required mb-1"
						>
							<template slot="label">
								{{$t('incomes.create.product')}} <span class="text-danger">*</span>
							</template>
							<multiselect v-model="selectedItem"
										 :options="goodsForMultiselect"
										 :searchable="true"
										 class="multiselect-pricing"
										 :show-labels="false"
										 :internal-search="false"
										 :loading="loading"
										 :close-on-select="true"
										 label="name"
										 track-by="id"
										 @search-change="loadItems($event)"
										 :placeholder="$t('incomes.create.product')">

								<template slot="singleLabel" slot-scope="props">
									{{ props.option.artikul }} / {{ props.option.color }} / {{ props.option.size
									}} / {{ props.option.name ? props.option.name.substring(0, 30) : '' }}
								</template>

								<template slot="option" slot-scope="option">
									{{ option.option.artikul }} / {{ option.option.color }} / {{ option.option.size
									}} / {{ option.option.name ? option.option.name.substring(0, 30) : '' }}
								</template>
							</multiselect>


						</b-form-group>
					</b-col>
					<template v-if="selectedItem !== null">
						<b-col cols="2">
							<span class="badge">{{ $t('incomes.balance') }}:</span> {{ balance }} <span>{{ unitName
								}}</span>
						</b-col>
						<b-col cols="4">
							<b-form-group
								breakpoint="lg"
								label-size="sm"
								label-cols="4"
								:label="$t('incomes.create.count')"
								label-for="refName"
								class="required"
							>
								<b-input-group size="sm">
									<b-form-input
										ref="inputQty"
										type="number"
										:required="true"
										size="sm"
										id="count"
										@focus="$event.target.select()"
										class="ml-1"
										v-model.number="qty"
										:placeholder="$t('incomes.create.count')"></b-form-input>
									<b-input-group-addon v-if="unitName">
										<b-button disabled size="sm">{{ unitName }}</b-button>
									</b-input-group-addon>
								</b-input-group>

							</b-form-group>
						</b-col>


					</template>

				</b-row>
				<b-row align-self="center" v-if="selectedItem !== null">
					<b-col align-self="center" cols="6">
						<template v-if="errorQtyMessage">
							<p v-if="balance === 0" class="text-center text-danger"> Ошибка! баланс ровно 0</p>
							<p v-else class="text-center text-danger"> Ошибка! Количество должен быть между от 0 до {{
								balance}}</p>
						</template>
					</b-col>
					<b-col align-self="center" cols="6">
						<b-button @click="addItemToWhItems" class="pull-right" :disabled="errorQtyMessage || balance === 0"
								  variant="primary">Добавить товар
						</b-button>
					</b-col>
				</b-row>
				<hr>
				<b-row>
					<b-col cols="6">
						<b-form-group
							size="sm"
							breakpoint="lg"
							label-size="sm"
							label-cols="4"
							:label="$t('incomes.comment')"
						>

							<b-textarea v-model="comment" :placeholder="$t('incomes.comment')"></b-textarea>
						</b-form-group>
					</b-col>
				</b-row>
				<div class="table-responsive table-wrapper">
					<b-table responsive="true" class="generalTableClass"
							 :items="whItems"
							 :fields="refField"
							 :per-page="0"
							 hover="hover"
							 striped="striped"
							 bordered="bordered"
							 show-empty
					>
						<template slot="actions" slot-scope="data">
							<b-link :key="data.item.id + 'delete'"
									@click="deleteItemFromList(data.item.itemId)"
									:id="'popOverDelete'+data.item.id"
							>
								<i class="fa fa-trash"></i>
							</b-link>
						</template>
					</b-table>

				</div>
				<!-- TABLE -->



		<div class="modal-actions">
			<b-row class="align-items-center">
				<b-col cols="6" class="mb-3 mb-xl-0">
					<b-row>
						<b-col cols="6">
							<b-button block size="sm" type="button" @click="cancel" variant="outline-danger">{{
								$t('cancel') }}
							</b-button>
						</b-col>
						<b-col cols="6">
							<b-button block type="button" size="sm" @click="save" variant="primary">{{ $t('save')
								}}
							</b-button>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</div>
		<b-modal
			v-model="acceptModal"
			hide-title="true"
			@ok="okAcceptModal"
			@cancel="cancelAcceptModal"
			ok-title="Да"
			cancel-title="Отмена"
		>
			<h5>Вы изменили отдел, в этом случае удаляется все добавленные товары. Продолжать? </h5>
		</b-modal>
		</b-card-body>
	</div>
</template>

<script>
	import {mapActions, mapGetters, mapState} from 'vuex';
	import Multiselect from 'vue-multiselect'
	import moment from 'moment'
	import MaskedInput from 'vue-masked-input'
	import ReferencesService from "../../../../services/references.sevice";
	import WhDocument from "../../../../services/wh-document.service";

	export default {
		name: 'Create',
		props:{
			mode: {
				type: String,
			},
			item: {
				type: Object,
			}
		},
		data() {
			return {
				selectedItem: null,
				loading: false,
				department: null,
				newDep: null,
				oldDep: null,
				message: false,
				errorQtyMessage: false,
				whItems: [],
				regDate: null,
				comment: null,
				fio: null,
				qty: null,
				unitName: '',
				balance: 0,
				shortageTypeId: null,
				list: [],
				refField: [
					{
						key: 'itemName',
						label: this.$t('incomes.create.product'),
						'class': 'not-first',
						sortable: true,
						visible: true,
					},
					{
						key: 'qty',
						label: this.$t('sale.kol-vo'),
					},
					/*{
						key: 'unit',
						label: 'единица',
						visible: false
					},*/
					{
						key: 'actions',
						label: this.$t('goods.actions'),
						'class': 'table_actions',
						visible: true,
					}
				],
				acceptModal: false,
			}
		},
		components: {Multiselect, MaskedInput},
		methods: {
			...mapActions('users', [
				'getMyDepartments'
			]),
			...mapActions('goods', [
				'fetchGoodsWithKeyword', 'fetchItemWithBarcode'
			]),
			async loadItems($event, by = 'name') {
				this.loading = true;

				await this.fetchGoodsWithKeyword($event);

				if (this.withKeywordError) {
					this.$vs.notify({
						text: this.withKeywordError,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
				this.loading = false;
			},
			loadList() {
				ReferencesService.getReferenceChildren(`shortage`).then(response => {
					this.list = response.data;
				})
			},
			cancel() {
				this.$emit('cancel');
			},
			save() {
				this.$validator.validate().then(valid => {
					if (valid && this.whItems.length !== 0) {
						let obj = {
							adjustmentItems: this.whItems,
							comment: this.comment,
							fio: this.fio,
							regDate: this.regDate,
							shortageTypeId: this.shortageTypeId,
							departmentId: this.department

						}

						if(this.mode == 'create'){
							this.$emit('ok',obj);
						}else{
							obj.id = this.item.id
							this.$emit('edit',obj);
						}

					} else {
						this.$vs.notify({
							title: this.$t('words.error'),
							text: 'Заполните все обязательное поле!',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					}
				});

			},
			deleteItemFromList(id){
				this.whItems.map((item,i) => {
					if(item.itemId === id){
						this.whItems.splice(i,1);
					}
				});
			},
			loadBalance(item) {
				WhDocument.balanceByItem(this.department, item).then(response => {
					this.balance = response.data;
				});
			},
			addItemToWhItems() {
				let obj = {
					count:this.balance,
					itemId: this.selectedItem.id,
					itemName: this.selectedItem.shortName,
					qty: this.qty,
					unit:this.selectedItem.unitName,
				};
				this.deleteItemFromList(obj.itemId);
				this.whItems.push(obj);
			},
			depSelected() {
				if (this.department !== this.oldDep && this.oldDep !== null) {
					this.acceptModal = true
				}

			},
			cancelAcceptModal() {
				this.department = this.oldDep
				this.acceptModal = false
			},
			okAcceptModal() {
				this.acceptModal = false;
				this.selectedItem = null
				this.qty = 0
				this.whItems = [];
				this.comment = null;
				this.shortageTypeId = null
				this.fio = null;
			},
			ifEdit(){
				this.department = this.item.departmentId;
				this.fio = this.item.fio;
				this.shortageTypeId = this.item.shortageTypeId;
				if(this.item.regDate){
					this.regDate = this.item.regDate;
				}

				if(this.item.comment){
					this.comment = this.item.comment
				}
				this.whItems = this.item.adjustmentItems



			},
			isCreate(){
				this.department = null;
				this.fio = null;
				this.shortageTypeId = null;
				this.comment = null
				this.whItems = [];
				this.selectedItem = null
			}


		},


		created() {
			this.regDate = moment().format('DD-MM-YYYY');
			this.getMyDepartments();
			this.loadItems(' ');
			this.loadList();

		},
		computed: {
			...mapGetters('users', [
				'myDeps'
			]),
			...mapState('goods', [
				'goodsForMultiselect'
			]),

		},
		watch: {
			selectedItem: {
				handler(newValue) {
					if (newValue !== null) {
						if (this.department === null) {
							this.message = true;
							this.unitName = '';
							this.selectedItem = null;
						} else {

							this.loadBalance(newValue.id)
							this.unitName = newValue.unitName;
							this.message = false;
						}
						this.qty = 0;
						this.errorQtyMessage = false
					}

				}
			},
			mode:{
				handler(newValue){
					if(newValue === 'edit'){
						this.ifEdit();
					}else{
						this.isCreate();
					}
				}
			},
			department: {
				handler(newValue, oldValue) {
					this.oldDep = oldValue;
				}
			},
			qty: {
				handler(newValue) {
					if (newValue < 0) {
						this.errorQtyMessage = true
					} else if (newValue > this.balance) {
						this.errorQtyMessage = true
					} else {
						this.errorQtyMessage = false
					}
				}
			}
		}

	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.table-wrapper {
		position: relative;
		padding: 5px;
	}
</style>
